import { z } from 'zod';

const NOTIFICATION_CHANNELS = ['', 'EMAIL', 'WEBHOOK', 'SMS', 'PUSH'] as const;
const NOTIFICATION_STATUSES = ['', 'PENDING', 'SENT', 'FAILED'] as const;
const NOTIFICATION_SEVERITIES = ['INFO', 'NOTICE', 'WARN', 'CRITICAL'] as const;

/** 이력 검색 필터 스키마 */
export const notificationHistorySearchSchema = z
  .object({
    channel: z.enum(NOTIFICATION_CHANNELS).optional(),
    status: z.enum(NOTIFICATION_STATUSES).optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    page: z.number().int().min(0).optional(),
    size: z.number().int().min(1).max(100).optional(),
    sort: z.string().optional(),
  })
  .refine(
    (v) => {
      if (v.from && v.to) {
        return new Date(v.from) <= new Date(v.to);
      }
      return true;
    },
    { message: '시작일은 종료일보다 이전이어야 합니다', path: ['from'] }
  );

export type NotificationHistorySearchFormValues = z.infer<typeof notificationHistorySearchSchema>;

/** 알림 발송 요청 스키마 */
export const sendNotificationSchema = z.object({
  channel: z.enum(['EMAIL', 'WEBHOOK', 'SMS', 'PUSH'] as const, {
    required_error: '채널을 선택해 주세요',
  }),
  target: z.string().min(1, '대상을 입력해 주세요').max(255),
  cc: z.string().optional(),
  title: z.string().max(200).optional(),
  text: z.string().min(1, '본문을 입력해 주세요').max(2000),
  severity: z.enum(NOTIFICATION_SEVERITIES).optional().default('INFO'),
});

export type SendNotificationFormValues = z.infer<typeof sendNotificationSchema>;
